// ScopedContractWidget.jsx — 회사별·통합 계약 위젯 (2026-10-19)
//   본사 '계약 관리' 위젯과 같은 부품(ContractByMarketerPanel·ContractByConsultantPanel·RecentContractsCard)을 그대로 쓰고
//   숫자만 그 화면 계약 주소에서 받는다(contractWidgetCodes.js). 제목 뒤 괄호 = '(통합)' 또는 회사 이름(작업 대상과 같은 이름).
import React, { useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { useCompanyNames } from '../adminlayout/useCompanyNames';
import { ContractByMarketerPanel } from './ContractByMarketerPanel';
import { ContractByConsultantPanel } from './ContractByConsultantPanel';
import { RecentContractsCard } from './RecentContractsCard';
import { groupRecentContracts } from './recentContractGroups';
import { getKstYmd, toList } from './utils';

const PART_LABEL = { marketer: '마케터별 계약', consultant: '상담자별 계약', recent: '최근 계약' };

/** 최근 계약 칸 — 그 화면 계약 목록을 받아 본사 위젯과 같은 방식으로 날짜를 묶는다. */
function ScopedRecentContracts({ code, title, base, accentOverride, sortableId, onClick }) {
  const [groups, setGroups] = useState(() => groupRecentContracts([], getKstYmd()));
  useEffect(() => {
    let cancelled = false;
    apiClient.get(base)
      .then((res) => { if (!cancelled) setGroups(groupRecentContracts(toList(res), getKstYmd())); })
      .catch(() => { if (!cancelled) setGroups(groupRecentContracts([], getKstYmd())); });
    return () => { cancelled = true; };
  }, [base]);
  return <RecentContractsCard code={code} title={title} groups={groups} accentOverride={accentOverride} sortableId={sortableId} onClick={onClick} />;
}

/** parsed = parseContractWidgetCode(code) */
export function ScopedContractWidget({ code, parsed, accentOverride, sortableId, onClick }) {
  const nameOf = useCompanyNames();
  const suffix = parsed.kind === 'integrated' ? '통합' : nameOf(parsed.companyCode);
  const title = `${PART_LABEL[parsed.part]} (${suffix})`;
  const common = { code, title, accentOverride, sortableId, onClick };
  if (parsed.part === 'marketer') return <ContractByMarketerPanel {...common} byMonthUrl={`${parsed.base}/by-month`} />;
  if (parsed.part === 'consultant') return <ContractByConsultantPanel {...common} byMonthUrl={`${parsed.base}/by-month`} />;
  return <ScopedRecentContracts {...common} base={parsed.base} />;
}
